export default {
  text: {
    order_cancelled: 'Tilaus peruutettu – kuljettajaa ei saatavilla',
    wolt_support: 'Kysyttävää? Soita suoraan Woltille <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>KIIREELLINEN:</strong> Hyväksy tai hylkää tilaus heti',
    no_driver_found: '<strong>Kuljettajaa ei löytynyt.</strong> Toimita tilaus itse tai peruuta se',
  },
  labels: {
    dummy_order: 'Testitilaus',
    items_one: '{{count}} tuote',
    items_other: '{{count}} tuotetta',
    needs_acceptance: 'Odottaa hyväksyntää',
    driver_pending: 'Odottaa kuljettajaa',
    driver_search_retrying: 'Etsitään yhä kuljettajaa',
    no_driver_found: 'Kuljettajaa ei löytynyt',
    today: 'Tänään',
    driver_assigned: 'Kuljettaja osoitettu',
    complete: 'Valmis',
  },
  buttons: {
    complete_order: 'Merkitse valmiiksi',
    looking_for_driver: 'Etsitään kuljettajaa...',
    click_to_remove: 'Napsauta poistaaksesi',
  },
};
